<template>

  <div id="buttomDown" style="width: 600px;height:400px;"></div>
</template>

<script>
  import echarts from 'echarts'
  export default {

    data() {
      return {

        dataXList: [],
        data1: [],
        data2: [],
        data3: [],
      }

    },
    props: {
      record: {
        type: Array,
      },
    },
    watch: {
      record: {
        handler: function(newVal) {
          if (!newVal) {
            return
          }


          for (var i = 0; i < newVal.length; i++) {

            this.dataXList.push(this.dateFormat("YYYY-mm-dd", new Date(newVal[i].days)));
            this.data1.push(newVal[i].intervalMax);
            this.data2.push(newVal[i].intervalMin);
            this.data3.push(newVal[i].intervalAvg);
          }

          this.drawLine();
        },

      },

    },
    mounted() {

    },
    methods: {

      // 格式化日期
      dateFormat(fmt, date) {
        let ret;
        const opt = {
          "Y+": date.getFullYear().toString(), // 年
          "m+": (date.getMonth() + 1).toString(), // 月
          "d+": date.getDate().toString(), // 日
          "H+": date.getHours().toString(), // 时
          "M+": date.getMinutes().toString(), // 分
          "S+": date.getSeconds().toString() // 秒
          // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        for (let k in opt) {
          ret = new RegExp("(" + k + ")").exec(fmt);
          if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
          };
        };
        return fmt;
      },

      drawLine() {

        var chartDom = document.getElementById('buttomDown');
        var myChart = echarts.init(chartDom);
        var option;

        option = {
          title: {
            text: '云平台相应间隔'
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: ['最长相应时间', '最短相应时间', '平均相应时间']
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.dataXList
          },
          yAxis: {
            type: 'value'
          },
          series: [{
              name: '最长相应时间',
              type: 'line',
              stack: '总量',
              data: this.data1
            },
            {
              name: '最短相应时间',
              type: 'line',
              stack: '总量',
              data: this.data2
            },

            {
              name: '平均相应时间',
              type: 'line',
              stack: '总量',
              data: this.data3
            }
          ]
        };

        option && myChart.setOption(option);

      }

    }
  }
</script>

<style>
</style>
